exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "ul[data-v-6bcdd0d4]{padding:0;list-style:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-6bcdd0d4&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Banet/errorsAndNotifications/BanetInfo.vue
// module id = 596
// module chunks = 0